var t = "__lodash_hash_undefined__";
function a(_) {
  return this.__data__.set(_, t), this;
}
export {
  a as default
};
